@if (bizEntity()) {
  <app-form-biz-entity
    [bizEntity]="bizEntity()!"
    [isEditing]="isEditing"
    [excludeParentAndOwner]="false"
    [delegateApiCall]="true"
    (saveRequested)="onSaveRequested($event)"
  ></app-form-biz-entity>
}
